<template>
<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">

<el-form-item label="设备ID" prop="id">
  <el-input v-model="ruleForm.id"></el-input>
</el-form-item>
<el-form-item label="是否在线" >
  <el-button @click="checkOnline()">点击检查</el-button>
</el-form-item>
<el-form-item label="授权类型" prop="type">
  <el-select v-model="ruleForm.type" placeholder="请选择授权类型">
    <el-option label="永久" value="forever"></el-option>
    <el-option label="天数" value="day"></el-option>
    <el-option label="次数" value="frequency"></el-option>
  </el-select>
</el-form-item>
<el-form-item  v-if="ruleForm.type=='day'" label="授权天数"  >
  <el-date-picker prop="day"
      v-model="value1"
      type="datetime"
      placeholder="选择结束日期时间">
      prop="day"
    </el-date-picker>
</el-form-item>
<el-form-item  v-if="ruleForm.type=='frequency'" label="授权次数" >
    <el-input v-model="ruleForm.time" placeholder="请输入授权次数" ></el-input>
</el-form-item>
<el-form-item label="设备名称" prop="remark">
  <el-input type="textarea" v-model="ruleForm.remark"></el-input>
</el-form-item>
<el-form-item>
  <el-button type="primary" @click="submitForm('ruleForm')">点击授权</el-button>
  <el-button @click="resetForm('ruleForm')">重置</el-button>
</el-form-item>
<el-form-item>
  <el-dialog title="授权码" :visible.sync="dialogFormVisible":close-on-click-modal="false">
  <el-form :model="form">
    <el-form-item label="授权码" :label-width="formLabelWidth">
      <el-input type="textarea" v-model="registerCode" autocomplete="off"></el-input>
    </el-form-item>
  </el-form>
  <div slot="footer" class="dialog-footer">
    <el-button type="success" @click="copyRegisterCode()">复制授权码</el-button>
    <el-button type="primary" @click="backHome()">关闭</el-button>
  </div>
</el-dialog>
</el-form-item>
</el-form>

</template>

  <script>
    export default {
      data() {
        return {
          params:[],
          pickerOptions: {
          shortcuts: [{
            text: '今天',
            onClick(picker) {
              picker.$emit('pick', new Date());
            }
          }, {
            text: '昨天',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit('pick', date);
            }
          }, {
            text: '一周前',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', date);
            }
          }]
        },
        value1: '',


          ruleForm: {
            id: '',
            type: '',
            remark: '',
            time:'',
            startTime:'',
            endTime:'',
            creatTime:''
          
          },
          dialogFormVisible: false,
          registerCode:'',
          rules: {
            id: [
              { required: true, message: '请输入设备ID', trigger: 'blur' }
            ],
            type: [
              { required: true, message: '请选择授权类型', trigger: 'change' }
            ],
            day:[
            { required: true, message: '请输入授权天数', trigger: 'blur' }
            ],
            remark:[
            { required: true, message: '请输入设备名称', trigger: 'blur' }
            ],
            
           
          }
        };
      },
      mounted() {
        console.log(this.$route.query.id)
        this.ruleForm.id=this.$route.query.id
        this.ruleForm.remark=this.$route.query.Name

     },
      methods: {
      
        submitForm(formName) {
         
          this.$refs[formName].validate((valid) => {
            if (valid) {
              if(this.ruleForm.time=="" && this.ruleForm.type=="frequency"){
                this.$message.error("请输入授权次数");
              }else{
                const timestamp = new Date().getTime();
                const date = new Date(timestamp);
                this.ruleForm.creatTime= date.toLocaleString();
                if(this.ruleForm.type=="day"){
                  const timestamp1 =this.value1.getTime();
                  const date1 = new Date(timestamp1);
                  this.ruleForm.endTime=date1.toLocaleString()
                }
                
                  
                this.request.post("/DeviceRegister", this.ruleForm).then(res => {
                if(res.code=='0'){
                      this.$message({message: '设备授权成功',type: 'success'});
                      this.registerCode=res.registerCode;
                      this.dialogFormVisible=true;
                     
                 }else{
                      this.$message.error(res.msg);
                }
            })
              }
               
            } else {
              console.log('error submit!!');
              return false;
            }
          });
        },
        //重置
        resetForm(formName) {
          this.$refs[formName].resetFields();
        },
        backHome(){
          this.dialogFormVisible = false
          this.$router.push('/home');
        },
        checkOnline(){
          this.request.get("/deviceOnlineState",{params:{"ID":this.ruleForm.id}}).then(res => {
            if(res.code=='0'){
              this.$message({message:res.data,type: 'success'});         
            }else{
              this.$message.error(res.msg);
            }
	   													
	   				}).catch(error => { console.log(error)})
        },
        copyRegisterCode() {
  // 创建临时文本域用于复制
  const textarea = document.createElement('textarea');
  textarea.value = this.registerCode;
  textarea.style.position = 'fixed';
  textarea.style.opacity = '0';
  document.body.appendChild(textarea);
  textarea.select();
  document.execCommand('copy');
  document.body.removeChild(textarea);
  
  // 显示复制成功提示
  this.$message({
    message: '授权码已复制到剪贴板',
    type: 'success'
  });
}
        


    
  }

}
    
  </script>